import React from 'react';
import b_ from 'b_';
import kebabCase from 'lodash/kebabCase';

import I18N from 'assets/i18n/brandlift-project';

import {PaymentStatus} from 'client/common/types';

import {BadgeViewProps, SurveyStateProps} from './types';

import './survey-state.css';

const i18n = I18N.common.surveyState;
const b = b_.with('survey-state');

function getModerationLabel(props: Pick<SurveyStateProps, 'verdict' | 'isSuper' | 'paymentStatus'>) {
    const {verdict, isSuper, paymentStatus} = props;

    if (verdict === 'REJECTED') {
        return i18n.rejectedByModeration;
    }

    if (verdict === 'RESTRICTED' && isSuper) {
        return i18n.restrictedByModeration;
    }

    if (paymentStatus === PaymentStatus.NOT_PAYED) {
        return i18n.requiresPayment;
    }

    return i18n.states.MODERATION;
}

function getLabel(props: Pick<SurveyStateProps, 'state' |'verdict' | 'isSuper' | 'paymentStatus'>) {
    const {state, verdict, isSuper, paymentStatus} = props;

    if (state === 'MODERATION') {
        return getModerationLabel({verdict, isSuper, paymentStatus});
    }

    if (state === 'DRAFT' && Boolean(paymentStatus)) {
        return `${i18n.states[state]} · ${i18n.payed}`;
    }

    return i18n.states[state];
}

function BadgeView(props: BadgeViewProps) {
    const {label, state, verdict, paymentStatus} = props;

    return (
        <span
            className={b('badge', {
                [kebabCase(state)]: true,
                [kebabCase(verdict)]: Boolean(verdict),
                notPayed: !paymentStatus
            })}
        >
            {label}
        </span>
    );
}

export default function SurveyState(props: SurveyStateProps) {
    const {
        bullet = false,
        className = '',
        isSuper,
        paymentStatus = PaymentStatus.PAYED,
        state,
        type = 'label',
        verdict
    } = props;

    const label = getLabel({state, verdict, isSuper, paymentStatus});

    if (type === 'text') {
        const rootClassName = `${b({
            [kebabCase(state)]: true,
            notPayed: !paymentStatus
        })} ${className}`;

        return (
            <div className={rootClassName}>
                {bullet && <span className={b('bullet')} />}
                <span className={b('label')}>{label}</span>
            </div>
        );
    }

    return <BadgeView label={label} state={state} verdict={verdict} paymentStatus={paymentStatus} />;
}
